import { jsx as h, jsxs as j, Fragment as it } from "react/jsx-runtime";
import * as f from "react";
import { useContext as Le, useState as ee, useCallback as lt, useEffect as V } from "react";
import { G as dt, u as ut, a as mt, T as ft, p as ht, b as P, c as Be, d as pt, s as gt, g as St, e as yt, f as ce, h as K, P as B, C as Re, i as bt, j as xt, k as Ct, l as vt, m as wt, _ as Tt, n as Et, o as kt, q as Mt, r as Ot, t as At, v as $t, w as Ft, x as It, y as _t } from "../ChatUi-PYOv1LKh.js";
import Pt from "../theme/index.es.js";
import '../main.css';function Nt(e) {
  return e == null || Object.keys(e).length === 0;
}
function ze(e) {
  const {
    styles: t,
    defaultTheme: o = {}
  } = e;
  return /* @__PURE__ */ h(dt, {
    styles: typeof t == "function" ? (n) => t(Nt(n) ? o : n) : t
  });
}
function Dt({
  styles: e,
  themeId: t,
  defaultTheme: o = {}
}) {
  const r = ut(o), n = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ h(ze, {
    styles: n
  });
}
const Fe = (e) => e, jt = () => {
  let e = Fe;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Fe;
    }
  };
}, Lt = jt();
function Ve(e) {
  var t, o, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (o = Ve(e[t])) && (r && (r += " "), r += o);
  } else for (o in e) e[o] && (r && (r += " "), r += o);
  return r;
}
function Bt() {
  for (var e, t, o = 0, r = "", n = arguments.length; o < n; o++) (e = arguments[o]) && (t = Ve(e)) && (r && (r += " "), r += t);
  return r;
}
const Rt = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function We(e, t, o = "Mui") {
  const r = Rt[t];
  return r ? `${o}-${r}` : `${Lt.generate(e)}-${t}`;
}
function zt(e, t, o = "Mui") {
  const r = {};
  return t.forEach((n) => {
    r[n] = We(e, n, o);
  }), r;
}
function re(e, t) {
  const o = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const n = r;
      if (n === "components" || n === "slots")
        o[n] = {
          ...e[n],
          ...o[n]
        };
      else if (n === "componentsProps" || n === "slotProps") {
        const a = e[n], s = t[n];
        if (!s)
          o[n] = a || {};
        else if (!a)
          o[n] = s;
        else {
          o[n] = {
            ...s
          };
          for (const c in a)
            if (Object.prototype.hasOwnProperty.call(a, c)) {
              const l = c;
              o[n][l] = re(a[l], s[l]);
            }
        }
      } else o[n] === void 0 && (o[n] = e[n]);
    }
  return o;
}
function Vt(e, t, o = void 0) {
  const r = {};
  for (const n in e) {
    const a = e[n];
    let s = "", c = !0;
    for (let l = 0; l < a.length; l += 1) {
      const i = a[l];
      i && (s += (c === !0 ? "" : " ") + t(i), c = !1, o && o[i] && (s += " " + o[i]));
    }
    r[n] = s;
  }
  return r;
}
const Ue = /* @__PURE__ */ f.createContext(null);
function ie() {
  return f.useContext(Ue);
}
const Wt = typeof Symbol == "function" && Symbol.for, Ut = Wt ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function Kt(e, t) {
  return typeof t == "function" ? t(e) : {
    ...e,
    ...t
  };
}
function Gt(e) {
  const {
    children: t,
    theme: o
  } = e, r = ie(), n = f.useMemo(() => {
    const a = r === null ? {
      ...o
    } : Kt(r, o);
    return a != null && (a[Ut] = r !== null), a;
  }, [o, r]);
  return /* @__PURE__ */ h(Ue.Provider, {
    value: n,
    children: t
  });
}
const Ht = /* @__PURE__ */ f.createContext();
function qt({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ h(Ht.Provider, {
    value: e ?? !0,
    ...t
  });
}
const Ke = /* @__PURE__ */ f.createContext(void 0);
function Yt({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ h(Ke.Provider, {
    value: e,
    children: t
  });
}
function Xt(e) {
  const {
    theme: t,
    name: o,
    props: r
  } = e;
  if (!t || !t.components || !t.components[o])
    return r;
  const n = t.components[o];
  return n.defaultProps ? re(n.defaultProps, r) : !n.styleOverrides && !n.variants ? re(n, r) : r;
}
function Jt({
  props: e,
  name: t
}) {
  const o = f.useContext(Ke);
  return Xt({
    props: e,
    name: t,
    theme: {
      components: o
    }
  });
}
const Ie = {};
function _e(e, t, o, r = !1) {
  return f.useMemo(() => {
    const n = e && t[e] || t;
    if (typeof o == "function") {
      const a = o(n), s = e ? {
        ...t,
        [e]: a
      } : a;
      return r ? () => s : s;
    }
    return e ? {
      ...t,
      [e]: o
    } : {
      ...t,
      ...o
    };
  }, [e, t, o, r]);
}
function Ge(e) {
  const {
    children: t,
    theme: o,
    themeId: r
  } = e, n = mt(Ie), a = ie() || Ie, s = _e(r, n, o), c = _e(r, a, o, !0), l = s.direction === "rtl";
  return /* @__PURE__ */ h(Gt, {
    theme: c,
    children: /* @__PURE__ */ h(ft.Provider, {
      value: s,
      children: /* @__PURE__ */ h(qt, {
        value: l,
        children: /* @__PURE__ */ h(Yt, {
          value: s == null ? void 0 : s.components,
          children: t
        })
      })
    })
  });
}
const Pe = {
  theme: void 0
};
function Qt(e) {
  let t, o;
  return function(n) {
    let a = t;
    return (a === void 0 || n.theme !== o) && (Pe.theme = n.theme, a = ht(e(Pe)), t = a, o = n.theme), a;
  };
}
const le = "mode", de = "color-scheme", Zt = "data-color-scheme";
function eo(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: o = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: n = le,
    colorSchemeStorageKey: a = de,
    attribute: s = Zt,
    colorSchemeNode: c = "document.documentElement",
    nonce: l
  } = e || {};
  let i = "", p = s;
  if (s === "class" && (p = ".%s"), s === "data" && (p = "[data-%s]"), p.startsWith(".")) {
    const x = p.substring(1);
    i += `${c}.classList.remove('${x}'.replace('%s', light), '${x}'.replace('%s', dark));
      ${c}.classList.add('${x}'.replace('%s', colorScheme));`;
  }
  const g = p.match(/\[([^\]]+)\]/);
  if (g) {
    const [x, C] = g[1].split("=");
    C || (i += `${c}.removeAttribute('${x}'.replace('%s', light));
      ${c}.removeAttribute('${x}'.replace('%s', dark));`), i += `
      ${c}.setAttribute('${x}'.replace('%s', colorScheme), ${C ? `${C}.replace('%s', colorScheme)` : '""'});`;
  } else
    i += `${c}.setAttribute('${p}', colorScheme);`;
  return /* @__PURE__ */ h("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? l : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${n}') || '${t}';
  const dark = localStorage.getItem('${a}-dark') || '${r}';
  const light = localStorage.getItem('${a}-light') || '${o}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${i}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function Ne(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function He(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function to(e) {
  return He(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function te(e, t) {
  if (typeof window > "u")
    return;
  let o;
  try {
    o = localStorage.getItem(e) || void 0, o || localStorage.setItem(e, t);
  } catch {
  }
  return o || t;
}
function oo(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: o,
    defaultDarkColorScheme: r,
    supportedColorSchemes: n = [],
    modeStorageKey: a = le,
    colorSchemeStorageKey: s = de,
    storageWindow: c = typeof window > "u" ? void 0 : window
  } = e, l = n.join(","), i = n.length > 1, [p, g] = f.useState(() => {
    const u = te(a, t), m = te(`${s}-light`, o), S = te(`${s}-dark`, r);
    return {
      mode: u,
      systemMode: Ne(u),
      lightColorScheme: m,
      darkColorScheme: S
    };
  }), [, x] = f.useState(!1), C = f.useRef(!1);
  f.useEffect(() => {
    i && x(!0), C.current = !0;
  }, [i]);
  const E = to(p), d = f.useCallback((u) => {
    g((m) => {
      if (u === m.mode)
        return m;
      const S = u ?? t;
      try {
        localStorage.setItem(a, S);
      } catch {
      }
      return {
        ...m,
        mode: S,
        systemMode: Ne(S)
      };
    });
  }, [a, t]), b = f.useCallback((u) => {
    u ? typeof u == "string" ? u && !l.includes(u) ? console.error(`\`${u}\` does not exist in \`theme.colorSchemes\`.`) : g((m) => {
      const S = {
        ...m
      };
      return He(m, (T) => {
        try {
          localStorage.setItem(`${s}-${T}`, u);
        } catch {
        }
        T === "light" && (S.lightColorScheme = u), T === "dark" && (S.darkColorScheme = u);
      }), S;
    }) : g((m) => {
      const S = {
        ...m
      }, T = u.light === null ? o : u.light, M = u.dark === null ? r : u.dark;
      if (T)
        if (!l.includes(T))
          console.error(`\`${T}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          S.lightColorScheme = T;
          try {
            localStorage.setItem(`${s}-light`, T);
          } catch {
          }
        }
      if (M)
        if (!l.includes(M))
          console.error(`\`${M}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          S.darkColorScheme = M;
          try {
            localStorage.setItem(`${s}-dark`, M);
          } catch {
          }
        }
      return S;
    }) : g((m) => {
      try {
        localStorage.setItem(`${s}-light`, o), localStorage.setItem(`${s}-dark`, r);
      } catch {
      }
      return {
        ...m,
        lightColorScheme: o,
        darkColorScheme: r
      };
    });
  }, [l, s, o, r]), k = f.useCallback((u) => {
    p.mode === "system" && g((m) => {
      const S = u != null && u.matches ? "dark" : "light";
      return m.systemMode === S ? m : {
        ...m,
        systemMode: S
      };
    });
  }, [p.mode]), I = f.useRef(k);
  return I.current = k, f.useEffect(() => {
    if (typeof window.matchMedia != "function" || !i)
      return;
    const u = (...S) => I.current(...S), m = window.matchMedia("(prefers-color-scheme: dark)");
    return m.addListener(u), u(m), () => {
      m.removeListener(u);
    };
  }, [i]), f.useEffect(() => {
    if (c && i) {
      const u = (m) => {
        const S = m.newValue;
        typeof m.key == "string" && m.key.startsWith(s) && (!S || l.match(S)) && (m.key.endsWith("light") && b({
          light: S
        }), m.key.endsWith("dark") && b({
          dark: S
        })), m.key === a && (!S || ["light", "dark", "system"].includes(S)) && d(S || t);
      };
      return c.addEventListener("storage", u), () => {
        c.removeEventListener("storage", u);
      };
    }
  }, [b, d, a, s, l, t, c, i]), {
    ...p,
    mode: C.current || !i ? p.mode : void 0,
    systemMode: C.current || !i ? p.systemMode : void 0,
    colorScheme: C.current || !i ? E : void 0,
    setMode: d,
    setColorScheme: b
  };
}
const ro = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function no(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: o = {},
    modeStorageKey: r = le,
    colorSchemeStorageKey: n = de,
    disableTransitionOnChange: a = !1,
    defaultColorScheme: s,
    resolveTheme: c
  } = e, l = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, i = /* @__PURE__ */ f.createContext(void 0), p = () => f.useContext(i) || l;
  function g(d) {
    var Ee, ke, Me, Oe, Ae;
    const {
      children: b,
      theme: k,
      modeStorageKey: I = r,
      colorSchemeStorageKey: u = n,
      disableTransitionOnChange: m = a,
      storageWindow: S = typeof window > "u" ? void 0 : window,
      documentNode: T = typeof document > "u" ? void 0 : document,
      colorSchemeNode: M = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: H = !1,
      disableStyleSheetGeneration: Ze = !1,
      defaultMode: et = "system"
    } = d, q = f.useRef(!1), Y = ie(), X = f.useContext(i), J = !!X && !H, ue = f.useMemo(() => k || (typeof o == "function" ? o() : o), [k]), me = ue[t], {
      colorSchemes: _ = {},
      components: tt = {},
      cssVarPrefix: fe,
      ...F
    } = me || ue, he = Object.keys(_).filter((v) => !!_[v]).join(","), N = f.useMemo(() => he.split(","), [he]), pe = typeof s == "string" ? s : s.light, ge = typeof s == "string" ? s : s.dark, ot = _[pe] && _[ge] ? et : ((ke = (Ee = _[F.defaultColorScheme]) == null ? void 0 : Ee.palette) == null ? void 0 : ke.mode) || ((Me = F.palette) == null ? void 0 : Me.mode), {
      mode: rt,
      setMode: Se,
      systemMode: ye,
      lightColorScheme: be,
      darkColorScheme: xe,
      colorScheme: nt,
      setColorScheme: Ce
    } = oo({
      supportedColorSchemes: N,
      defaultLightColorScheme: pe,
      defaultDarkColorScheme: ge,
      modeStorageKey: I,
      colorSchemeStorageKey: u,
      defaultMode: ot,
      storageWindow: S
    });
    let Q = rt, A = nt;
    J && (Q = X.mode, A = X.colorScheme);
    const ve = A || F.defaultColorScheme, st = ((Oe = F.generateThemeVars) == null ? void 0 : Oe.call(F)) || F.vars, $ = {
      ...F,
      components: tt,
      colorSchemes: _,
      cssVarPrefix: fe,
      vars: st
    };
    if (typeof $.generateSpacing == "function" && ($.spacing = $.generateSpacing()), ve) {
      const v = _[ve];
      v && typeof v == "object" && Object.keys(v).forEach((w) => {
        v[w] && typeof v[w] == "object" ? $[w] = {
          ...$[w],
          ...v[w]
        } : $[w] = v[w];
      });
    }
    const L = F.colorSchemeSelector;
    f.useEffect(() => {
      if (A && M && L && L !== "media") {
        const v = L;
        let w = L;
        if (v === "class" && (w = ".%s"), v === "data" && (w = "[data-%s]"), v != null && v.startsWith("data-") && !v.includes("%s") && (w = `[${v}="%s"]`), w.startsWith("."))
          M.classList.remove(...N.map((z) => w.substring(1).replace("%s", z))), M.classList.add(w.substring(1).replace("%s", A));
        else {
          const z = w.replace("%s", A).match(/\[([^\]]+)\]/);
          if (z) {
            const [$e, Z] = z[1].split("=");
            Z || N.forEach((ct) => {
              M.removeAttribute($e.replace(A, ct));
            }), M.setAttribute($e, Z ? Z.replace(/"|'/g, "") : "");
          } else
            M.setAttribute(w, A);
        }
      }
    }, [A, L, M, N]), f.useEffect(() => {
      let v;
      if (m && q.current && T) {
        const w = T.createElement("style");
        w.appendChild(T.createTextNode(ro)), T.head.appendChild(w), window.getComputedStyle(T.body), v = setTimeout(() => {
          T.head.removeChild(w);
        }, 1);
      }
      return () => {
        clearTimeout(v);
      };
    }, [A, m, T]), f.useEffect(() => (q.current = !0, () => {
      q.current = !1;
    }), []);
    const at = f.useMemo(() => ({
      allColorSchemes: N,
      colorScheme: A,
      darkColorScheme: xe,
      lightColorScheme: be,
      mode: Q,
      setColorScheme: Ce,
      setMode: Se,
      systemMode: ye
    }), [N, A, xe, be, Q, Ce, Se, ye]);
    let we = !0;
    (Ze || F.cssVariables === !1 || J && (Y == null ? void 0 : Y.cssVarPrefix) === fe) && (we = !1);
    const Te = /* @__PURE__ */ j(f.Fragment, {
      children: [/* @__PURE__ */ h(Ge, {
        themeId: me ? t : void 0,
        theme: c ? c($) : $,
        children: b
      }), we && /* @__PURE__ */ h(ze, {
        styles: ((Ae = $.generateStyleSheets) == null ? void 0 : Ae.call($)) || []
      })]
    });
    return J ? Te : /* @__PURE__ */ h(i.Provider, {
      value: at,
      children: Te
    });
  }
  const x = typeof s == "string" ? s : s.light, C = typeof s == "string" ? s : s.dark;
  return {
    CssVarsProvider: g,
    useColorScheme: p,
    getInitColorSchemeScript: (d) => eo({
      colorSchemeStorageKey: n,
      defaultLightColorScheme: x,
      defaultDarkColorScheme: C,
      modeStorageKey: r,
      ...d
    })
  };
}
const ne = {
  standard: "standard",
  chat_ui: "chat-ui",
  global_head: "global-head"
}, O = {
  extra_small: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  extra_large: "xl",
  extra_extra_large: "xxl"
}, so = "ui-suite", y = {
  primary: {
    110: "#1A6799",
    100: "#1D76AF",
    90: "#2081BF",
    10: "#D3EAF8",
    5: "#E9F4FB",
    contrastText: "#FFFFFF"
  },
  secondary: {
    110: "#8B0E15",
    100: "#A21018",
    90: "#B5121B",
    10: "#FAD1D3",
    5: "#FDE8E9",
    contrastText: "#FFFFFF"
  },
  cta: {
    110: "#354F17",
    100: "#43631D",
    90: "#567F25",
    10: "#E7F4D7",
    5: "#F3F9EB",
    contrastText: "#FFFFFF"
  },
  warning: {
    110: "#AE3805",
    100: "#C13E05",
    90: "#D44406",
    10: "#6C9F2E",
    5: "#FEEDE6",
    contrastText: "#FFFFFF"
  },
  grey: {
    100: "#0D0D0D",
    90: "#1A1A1A",
    80: "#333333",
    70: "#4D4D4D",
    60: "#666666",
    50: "#808080",
    40: "#999999",
    30: "#B3B3B3",
    20: "#CCCCCC",
    10: "#E6E6E6",
    5: "#F2F2F2",
    0: "#FFFFFF"
  }
};
function De({
  theme: e,
  ...t
}) {
  const o = P in e ? e[P] : void 0;
  return /* @__PURE__ */ h(Ge, {
    ...t,
    themeId: o ? P : void 0,
    theme: o || e
  });
}
const W = {
  attribute: "data-mui-color-scheme",
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: ao,
  useColorScheme: sr,
  getInitColorSchemeScript: ar
} = no({
  themeId: P,
  // @ts-ignore ignore module augmentation tests
  theme: () => Be({
    cssVariables: !0
  }),
  colorSchemeStorageKey: W.colorSchemeStorageKey,
  modeStorageKey: W.modeStorageKey,
  defaultColorScheme: {
    light: W.defaultLightColorScheme,
    dark: W.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: pt(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return gt({
        sx: r,
        theme: this
      });
    }, t;
  }
}), co = ao;
function io({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ h(De, {
    theme: e,
    ...t
  }) : "colorSchemes" in (P in e ? e[P] : e) ? /* @__PURE__ */ h(co, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ h(De, {
    theme: e,
    ...t
  });
}
var lo = function(t) {
  return uo(t) && !mo(t);
};
function uo(e) {
  return !!e && typeof e == "object";
}
function mo(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || po(e);
}
var fo = typeof Symbol == "function" && Symbol.for, ho = fo ? Symbol.for("react.element") : 60103;
function po(e) {
  return e.$$typeof === ho;
}
function go(e) {
  return Array.isArray(e) ? [] : {};
}
function R(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? D(go(e), e, t) : e;
}
function So(e, t, o) {
  return e.concat(t).map(function(r) {
    return R(r, o);
  });
}
function yo(e, t) {
  if (!t.customMerge)
    return D;
  var o = t.customMerge(e);
  return typeof o == "function" ? o : D;
}
function bo(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function je(e) {
  return Object.keys(e).concat(bo(e));
}
function qe(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function xo(e, t) {
  return qe(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function Co(e, t, o) {
  var r = {};
  return o.isMergeableObject(e) && je(e).forEach(function(n) {
    r[n] = R(e[n], o);
  }), je(t).forEach(function(n) {
    xo(e, n) || (qe(e, n) && o.isMergeableObject(t[n]) ? r[n] = yo(n, o)(e[n], t[n], o) : r[n] = R(t[n], o));
  }), r;
}
function D(e, t, o) {
  o = o || {}, o.arrayMerge = o.arrayMerge || So, o.isMergeableObject = o.isMergeableObject || lo, o.cloneUnlessOtherwiseSpecified = R;
  var r = Array.isArray(t), n = Array.isArray(e), a = r === n;
  return a ? r ? o.arrayMerge(e, t, o) : Co(e, t, o) : R(t, o);
}
D.all = function(t, o) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, n) {
    return D(r, n, o);
  }, {});
};
var vo = D, wo = vo;
const To = /* @__PURE__ */ St(wo), Eo = {
  primary: {
    main: y.primary[110],
    light: y.primary[100],
    dark: y.primary[90],
    ...y.primary
  },
  secondary: {
    main: y.secondary[110],
    light: y.secondary[100],
    dark: y.secondary[90],
    ...y.secondary
  },
  success: {
    main: y.cta[110],
    light: y.cta[100],
    dark: y.cta[90],
    ...y.cta
  },
  grey: {
    900: y.grey[100],
    800: y.grey[90],
    700: y.grey[80],
    600: y.grey[70],
    500: y.grey[60],
    400: y.grey[50],
    300: y.grey[40],
    200: y.grey[30],
    100: y.grey[20],
    50: y.grey[10],
    A100: y.grey[0],
    ...y.grey
  },
  warning: {
    main: y.warning[110],
    light: y.warning[100],
    dark: y.warning[90],
    ...y.warning
  }
}, ko = {
  fontFamily: "myriad-pro, sans-serif"
}, Mo = {
  [O.extra_small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [O.small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [O.medium]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [O.large]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [O.extra_large]: {
    columns: {
      full: "1152px",
      gutter: "24px",
      3: "270px"
    }
  },
  [O.extra_extra_large]: {
    columns: {
      full: "1288px",
      gutter: "32px",
      3: "298px"
    }
  }
}, Oo = [
  "none",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.45)",
  "0px 2px 4px 0px rgba(26, 26, 26, 0.16)",
  "0px 2px 4px 0px rgba(26, 26, 26, 0.24)",
  "0px 4px 4px 0px rgba(26, 26, 26, 0.24)",
  "0px 4px 4px 0px rgba(26, 26, 26, 0.32)"
], Ao = {
  ribbon: 1250
}, $o = {
  borderRadius: "10px",
  gridVertical: "0.5rem",
  letterBetween: "0rem",
  lineHeight: "130%"
}, Fo = [
  "none",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.08)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.16)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.24)",
  "0px 8px 16px 0px rgba(26, 26, 26, 0.32)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.4)"
], oe = {
  values: {
    [O.extra_small]: 0,
    [O.small]: 576,
    [O.medium]: 768,
    [O.large]: 992,
    [O.extra_large]: 1200,
    [O.extra_extra_large]: 1440
  }
}, Io = (e) => ({
  [ne.global_head]: oe,
  [ne.standard]: oe
})[e] ?? oe, _o = (e) => ({
  typography: ko,
  palette: Eo,
  spacing: (t) => `${t * 8}px`,
  shadows: Oo,
  zIndex: Ao,
  customSpacing: $o,
  customBoxShadowInner: Fo,
  breakpoints: {
    ...Io(e),
    contentGrids: Mo
  }
}), Po = (e, t = {}, o = !1) => {
  const r = Object.keys(t).length === 0 || o ? _o(e) : {}, n = To(r, t);
  return Be({
    cssVariables: !0,
    cssVarPrefix: so,
    ...n
  });
};
function No(e) {
  return /* @__PURE__ */ h(Dt, {
    ...e,
    defaultTheme: yt,
    themeId: P
  });
}
function Ye(e) {
  return function(o) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ h(No, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...o
        }) : e
      })
    );
  };
}
function Xe(e) {
  return Jt(e);
}
const se = typeof Ye({}) == "function", Do = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t && !e.vars && {
    colorScheme: e.palette.mode
  }
}), jo = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), Je = (e, t = !1) => {
  var a, s;
  const o = {};
  t && e.colorSchemes && typeof e.getColorSchemeSelector == "function" && Object.entries(e.colorSchemes).forEach(([c, l]) => {
    var p, g;
    const i = e.getColorSchemeSelector(c);
    i.startsWith("@") ? o[i] = {
      ":root": {
        colorScheme: (p = l.palette) == null ? void 0 : p.mode
      }
    } : o[i.replace(/\s*&/, "")] = {
      colorScheme: (g = l.palette) == null ? void 0 : g.mode
    };
  });
  let r = {
    html: Do(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: {
      margin: 0,
      // Remove the margin in all browsers.
      ...jo(e),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    },
    ...o
  };
  const n = (s = (a = e.components) == null ? void 0 : a.MuiCssBaseline) == null ? void 0 : s.styleOverrides;
  return n && (r = [r, n]), r;
}, U = "mui-ecs", Lo = (e) => {
  const t = Je(e, !1), o = Array.isArray(t) ? t[0] : t;
  return !e.vars && o && (o.html[`:root:has(${U})`] = {
    colorScheme: e.palette.mode
  }), e.colorSchemes && Object.entries(e.colorSchemes).forEach(([r, n]) => {
    var s, c;
    const a = e.getColorSchemeSelector(r);
    a.startsWith("@") ? o[a] = {
      [`:root:not(:has(.${U}))`]: {
        colorScheme: (s = n.palette) == null ? void 0 : s.mode
      }
    } : o[a.replace(/\s*&/, "")] = {
      [`&:not(:has(.${U}))`]: {
        colorScheme: (c = n.palette) == null ? void 0 : c.mode
      }
    };
  }), t;
}, Bo = Ye(se ? ({
  theme: e,
  enableColorScheme: t
}) => Je(e, t) : ({
  theme: e
}) => Lo(e));
function Ro(e) {
  const t = Xe({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: o,
    enableColorScheme: r = !1
  } = t;
  return /* @__PURE__ */ j(f.Fragment, {
    children: [se && /* @__PURE__ */ h(Bo, {
      enableColorScheme: r
    }), !se && !r && /* @__PURE__ */ h("span", {
      className: U,
      style: {
        display: "none"
      }
    }), o]
  });
}
const zo = Qt;
function Vo(e) {
  return We("MuiSvgIcon", e);
}
zt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Wo = (e) => {
  const {
    color: t,
    fontSize: o,
    classes: r
  } = e, n = {
    root: ["root", t !== "inherit" && `color${K(t)}`, `fontSize${K(o)}`]
  };
  return Vt(n, Vo, r);
}, Uo = ce("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "inherit" && t[`color${K(o.color)}`], t[`fontSize${K(o.fontSize)}`]];
  }
})(zo(({
  theme: e
}) => {
  var t, o, r, n, a, s, c, l, i, p, g, x, C, E;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (n = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : n.call(t, "fill", {
      duration: (r = (o = (e.vars ?? e).transitions) == null ? void 0 : o.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (d) => !d.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((s = (a = e.typography) == null ? void 0 : a.pxToRem) == null ? void 0 : s.call(a, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : l.call(c, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((p = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : p.call(i, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, d]) => d && d.main).map(([d]) => {
        var b, k;
        return {
          props: {
            color: d
          },
          style: {
            color: (k = (b = (e.vars ?? e).palette) == null ? void 0 : b[d]) == null ? void 0 : k.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (x = (g = (e.vars ?? e).palette) == null ? void 0 : g.action) == null ? void 0 : x.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (E = (C = (e.vars ?? e).palette) == null ? void 0 : C.action) == null ? void 0 : E.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), G = /* @__PURE__ */ f.forwardRef(function(t, o) {
  const r = Xe({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: n,
    className: a,
    color: s = "inherit",
    component: c = "svg",
    fontSize: l = "medium",
    htmlColor: i,
    inheritViewBox: p = !1,
    titleAccess: g,
    viewBox: x = "0 0 24 24",
    ...C
  } = r, E = /* @__PURE__ */ f.isValidElement(n) && n.type === "svg", d = {
    ...r,
    color: s,
    component: c,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: x,
    hasSvgAsChild: E
  }, b = {};
  p || (b.viewBox = x);
  const k = Wo(d);
  return /* @__PURE__ */ j(Uo, {
    as: c,
    className: Bt(k.root, a),
    focusable: "false",
    color: i,
    "aria-hidden": g ? void 0 : !0,
    role: g ? "img" : void 0,
    ref: o,
    ...b,
    ...C,
    ...E && n.props,
    ownerState: d,
    children: [E ? n.props.children : n, g ? /* @__PURE__ */ h("title", {
      children: g
    }) : null]
  });
});
G && (G.muiName = "SvgIcon");
function Ko(e, t) {
  function o(r, n) {
    return /* @__PURE__ */ h(G, {
      "data-testid": `${t}Icon`,
      ref: n,
      ...r,
      children: e
    });
  }
  return o.muiName = G.muiName, /* @__PURE__ */ f.memo(/* @__PURE__ */ f.forwardRef(o));
}
const Go = Ko(/* @__PURE__ */ h("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown"), ae = {
  BUTTON: "ql-launch-chat-button",
  CONTAINER: "ql-launch-chat-container",
  OPEN_ICON: "ql-launch-chat-icon-open"
}, Ho = { ...ae }, qo = {
  BUTTON: "Ask Chat"
}, Yo = ce("div")(({ theme: e }) => {
  var t, o, r, n;
  return `
    position: fixed;
    display: flex;
    background-color: ${(o = (t = e == null ? void 0 : e.vars) == null ? void 0 : t.palette) == null ? void 0 : o.primary[90]};
    right: 16px;
    bottom: 16px;
    z-index: 40;
    border-radius: 100px;
    box-shadow: ${(r = e == null ? void 0 : e.vars) == null ? void 0 : r.shadows[1]};
    overflow: hidden;
    padding: 0;
    button {
        cursor: pointer;
        span {
          pointer-events: none;
        }
        span * {
          pointer-events: none;
        }
    }
    ${(n = e == null ? void 0 : e.breakpoints) == null ? void 0 : n.up("sm")} {
      right: 24px;
      bottom: 24px;
    }
`;
}), Xo = ce("button")(({ theme: e }) => {
  var t, o, r, n, a, s, c, l, i;
  return `
    background-color: ${(o = (t = e == null ? void 0 : e.vars) == null ? void 0 : t.palette) == null ? void 0 : o.primary[90]};
    border-radius: 100px;
    display: flex;
    box-sizing: border-box;
    padding: 7px 15px;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    overflow: hidden;
    user-select: none;
    span {
      color: ${(a = (n = (r = e == null ? void 0 : e.vars) == null ? void 0 : r.palette) == null ? void 0 : n.primary) == null ? void 0 : a.contrastText};
      font-size: 16px;
      font-weight: 600;
      transition: max-width 0.3s ease-out;
      white-space: nowrap;
      overflow: hidden;
    }
    ${(s = e == null ? void 0 : e.breakpoints) == null ? void 0 : s.up("sm")} {
      padding: 15px;
      span.open {
        max-width: 0; 
      }
      span.close {
        max-width: 76px;
        margin-left: 8px;
      }
    }
    svg {
      width: 26px;
      height: 26px;
      flex-grow: 1;
      fill: ${(i = (l = (c = e == null ? void 0 : e.vars) == null ? void 0 : c.palette) == null ? void 0 : l.primary) == null ? void 0 : i.contrastText};
    }
`;
}), Qe = ({ onClick: e, testId: t = null, className: o = null }) => {
  const { chatWindowOpen: r } = Le(Re);
  return /* @__PURE__ */ h(Yo, { children: /* @__PURE__ */ j(
    Xo,
    {
      "data-testid": t || ae.BUTTON,
      className: `${Ho.BUTTON} ${o}`,
      "aria-expanded": r,
      onClick: e,
      children: [
        r ? /* @__PURE__ */ h(Go, { "data-testid": ae.OPEN_ICON }) : bt,
        /* @__PURE__ */ h("span", { className: r ? "open" : "close", children: qo.BUTTON })
      ]
    }
  ) });
};
Qe.propTypes = {
  onClick: B.func,
  testId: B.string,
  className: B.string
};
const Jo = () => {
  const { hostname: e } = Et(), { getSession: t } = xt(), { getUser: o } = Ct(), n = vt("CHAT_API") ? window.fetch : kt, a = wt(e);
  return async () => {
    var g;
    const { botSessionId: s, hasHistory: c } = t(), { userId: l } = o({ botSessionId: s }), i = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Chat-Session-Id": s,
        "X-Chat-User-Id": l
      }
    }, p = [];
    if (!c) return p;
    try {
      const x = new Promise(
        (d, b) => setTimeout(() => b(new Error("Request timed out")), 2e3)
      ), C = await Promise.race([n((g = Tt[a]) == null ? void 0 : g.BFF_HISTORY_URL, i), x]);
      if (!C) return p;
      if (C.status !== 200) return !1;
      const E = await C.json();
      for (const d of E.history)
        p.push({
          role: "user",
          message: d.message
        }), p.push({
          role: "assistant",
          message: {
            response: d.chat.response,
            interactionId: d.chat.interactionId,
            intent: d.chat.intent,
            epochSeconds: d.chat.epochSeconds,
            botSessionId: d.chat.botSessionId,
            cta: d.ctas,
            userLikedResponse: d.chat.userLikedResponse
          }
        });
    } catch (x) {
      console.error("Error fetching chat history", x);
    }
    return p;
  };
}, Qo = () => () => {
  var o, r;
  const e = ((o = window == null ? void 0 : window.localStorage) == null ? void 0 : o.getItem("chatTab")) === "true", t = ((r = window == null ? void 0 : window.sessionStorage) == null ? void 0 : r.getItem("chatTab")) === "true";
  return { globalTab: e, tab: t };
};
function Zo() {
  const { chatWindowOpen: e, setChatWindowOpen: t, setLoadingHistory: o, loadingHistory: r } = Le(
    Re
  ), [n, a] = ee(!1), s = Jo(), { trackEvent: c } = Ot(), l = lt(async () => {
    if (a(!e), e)
      t(!1), o(!1);
    else {
      o(!0);
      const d = await s();
      x(d || []), o(!1);
    }
  }, [e, s, t, o]), [i, p] = ee(!0), [g, x] = ee(null), C = Qo(), { isDesktop: E } = At();
  return V(() => {
    const { globalTab: d, tab: b } = C();
    E() && g === null && (d || b) && l();
  }, [C, l, g, E]), V(() => {
    Array.isArray(g) && n && (a(!1), t(!0, "history"));
  }, [n, C, g, r, t]), V(() => {
    const d = (b) => {
      var k, I, u, m;
      String((k = b == null ? void 0 : b.target) == null ? void 0 : k.nodeName).match(/button|a/i) && !String((I = b == null ? void 0 : b.target) == null ? void 0 : I.className).match(/ql-launch|ql-assistant/) && !String((m = (u = b == null ? void 0 : b.target) == null ? void 0 : u.parentElement) == null ? void 0 : m.className).match(/ql-launch|ql-assistant|action-button-container/) && t(!1, "external");
    };
    return document.body.addEventListener("click", d), () => {
      document.body.removeEventListener("click", d);
    };
  }, [t]), V(() => {
    c({ event: "chatbot_view" });
  }, [c]), /* @__PURE__ */ j(it, { children: [
    e ? /* @__PURE__ */ h(Mt, { history: g }) : null,
    i && /* @__PURE__ */ h(Qe, { onClick: l })
  ] });
}
const er = ({ link: e, overrides: t = {} }) => {
  const { contentLinks: o = {}, domainOverride: r = {} } = t, n = _t();
  n.data = { ...n.data, ...o, domainOverride: r };
  const a = $t({
    cssVariables: !0,
    cssPrefix: "chat",
    ...Po(ne.chat_ui, Pt, !0)
  });
  return /* @__PURE__ */ h(Ft, { children: /* @__PURE__ */ h(It, { link: e, children: /* @__PURE__ */ j(io, { theme: a, children: [
    /* @__PURE__ */ h(Ro, {}),
    /* @__PURE__ */ h(Zo, { link: e })
  ] }) }) });
};
er.propTypes = {
  link: B.elementType,
  overrides: B.object
};
export {
  er as default
};
//# sourceMappingURL=index.es.js.map
